/* script */
//
//
//
//
//
//

// Components
import ControlDecorator from './ControlDecorator.vue';

/**
 * Base control component interface: inputs, textarea, and select common interface.
 *
 * @vue-prop {String} name the vue component to use for the step.
 * @vue-prop {String[]} errors the field errors array
 * @vue-prop {String} [label] the label for this field.
 * @vue-prop {String} [value] the field initial value
 * @vue-prop {String} [placeholder] a placeholder text for this field
 * @vue-prop {String} [tip] tips of the control (tooltip on the label)
 * @vue-prop {String} [hint] an optional explanation paragraph
 * @vue-prop {Boolean} [focused] an optional flag to set focus on the input
 * @vue-prop {Boolean} [disabled] an optional flag to disable the input
 * @vue-prop {String} [autocomplete] an optional autocomplete flag for the input
 *
 * @category ui.components.form-elements
 * @exports BaseControl
 * @component
 */
const __vue_script__ = {
    name: 'BaseControl',

    components: { ControlDecorator },

    props: {
        name: {
            type: String,
            required: true
        },

        errors: {
            type: Array,
            default: () => []
        },

        statuses: {
            type: Object,
            default: () => ({})
        },

        label: {
            type: String,
            default: null
        },

        value: {
            type: String,
            default: null
        },

        placeholder: {
            type: String,
            default: null
        },

        tip: {
            type: String,
            default: null
        },

        hint: {
            type: String,
            default: null
        },

        hintAfterLabel: {
            type: Boolean,
            default: false
        },

        focused: {
            type: Boolean,
            default: null
        },

        disabled: {
            type: Boolean,
            default: null
        },

        autocomplete: {
            type: String,
            default: null
        },

        hasDefault: {
            type: Boolean,
            default: false
        },

        warning: {
            type: String,
            default: null
        },

        legacy: {
            type: Object,
            default: () => ({})
        },

        event: {
            type: Object,
            default: () => ({})
        },

        dependant: {
            type: Boolean,
            default: false
        },

        edit: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        uid() {
            return `${this.name}-${this._uid}`;
        },

        // Pass-through listeners
        listeners() {
            // Here we skip the `input` and `change` listeners, since we provide our own
            // and we don't want it to be overwritten.

            // eslint-disable-next-line
            const { input, change, ...listeners } = this.$listeners;

            return listeners;
        },
    },

    watch: {
        focused() {
            this.attemptFocus();
        }
    },

    created() {
        if (this.hasDefault && (this.value === null || typeof this.value === 'undefined')) {
            // IF the control has a default value, AND the value is not set yet (null or undefined),
            // then emit the input event to populate the form with that value.
            this.input();
        }
    },

    mounted() {
        this.attemptFocus();
    },

    methods: {
        /**
         * Tries to grab the focus on the input element
         */
        attemptFocus() {
            if (this.focused && this.$refs.input) {
                this.focus();
            }
        },

        /**
         * Grabs the focus on the input element
         */
        focus() {
            setTimeout(() => {
                this.$refs.input.focus();
                this.$emit('focused');
            }, 250);
        },

        /**
         * Blurs on the input element
         */
        blur() {
            this.$refs.input.blur();
        },

        /**
         * Triggered when user interacts with input components.
         *
         * @param {Object} [$event] the event that triggered the change
         */
        input($event) {
            let value = this.value;
            if ($event?.target) {
                value = $event.target.value;
            }

            if (typeof value === 'number') {
                value = Number.parseFloat(value);
            }

            this.$emit('input', value);
        },

        /**
         * Triggered when user interacts with selects component.
         *
         * @param {Object} $event the event that triggered the change
         */
        change($event) {
            this.input($event);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-control"},[_c('input',{on:{"input":_vm.input}}),_c('select',{on:{"change":_vm.change}},[_c('option',{attrs:{"value":"value","selected":"selected"}})])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "BaseControl.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__